import * as UI from "@iyk/ui"
import * as React from "react"

import { AnimatePresence, motion } from "motion/react"

type LoadingImageProps = Omit<React.ComponentProps<"img">, "onLoad" | "onError"> & {
  spinnerClassName?: string
}

export const LoadingImage = ({ spinnerClassName, ...imgProps }: LoadingImageProps) => {
  const [isSettled, setIsSettled] = React.useState(false)
  const imageRef = React.useRef<HTMLImageElement>(null)

  React.useEffect(() => {
    if (imageRef.current?.complete) {
      setIsSettled(true)
    }
  }, [])

  const settle = () => {
    setIsSettled(true)
  }

  return (
    <>
      <img ref={imageRef} onLoad={settle} onError={settle} {...imgProps} />
      <AnimatePresence>
        {!isSettled && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            className="z-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid place-content-center"
          >
            <UI.Icon.LoadingSpinner className={UI.cx("size-4", spinnerClassName)} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
